import * as React from "react";
import { render } from "react-dom";
import { I18nextProvider } from "react-i18next";
import i18next from "./plugins/i18nextPlugin";
import { unregister } from "./registerServiceWorker";
import { AppRouter } from "./router";
import ModalContainer from "react-modal-promise";
import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { store } from "./redux/store";

// css
import "bootstrap/dist/css/bootstrap.min.css";
import "react-tippy/dist/tippy.css";
// import "./style.scss";
// import "./theme-arka.scss";

// Moment config
import Moment from "moment";
import "moment/locale/fr";
import Favicon from "react-favicon";
import ThemeSelector from "./components/themes/ThemeSelector";

Moment.locale("fr");

/**
 * Plug our routed app to themes and other stuff like i18n
 */
const App = () => {
  const href = window.location.href;
  const hubTheme = href.search('hub');
  document.title = hubTheme !== -1 ? `Hub studio` : 'Arka studio';
  const faviconUrl = hubTheme !== -1 ? `assets/favicon.png` : 'assets/favicon-arka.png';
  return <ThemeSelector>
    <Provider store={store}>
      <I18nextProvider i18n={i18next}>
        <Favicon url={faviconUrl} />
        <AppRouter />
        <ModalContainer />
        <ToastContainer />
      </I18nextProvider>
    </Provider>
  </ThemeSelector>
};

// Bootstrap app on DOM
render(<App />, document.getElementById("root"));
unregister(); // Remove all service worker as they may cause cache problem



// WEBPACK FOOTER //
// ./src/index.tsx